import { useCurrentStateAndParams, useRouter } from '@uirouter/react';

import { useUnauthorizedRedirect } from '@/react/hooks/useUnauthorizedRedirect';
import { useEnvironment } from '@/react/portainer/environments/queries/useEnvironment';
import { useGroup } from '@/react/portainer/environments/environment-groups/queries';
import { EnvironmentId } from '@/react/portainer/environments/types';

import { PageHeader } from '@@/PageHeader';

import { EnvironmentDetailsWidget } from './EnvironmentDetailsWidget';
import { CreateAccessWidget } from './CreateAccessWidget';
import { AccessDatatableWrapper } from './AccessDatatableWrapper';

export function AccessView() {
  useUnauthorizedRedirect(
    { authorizations: ['EndpointResourcesAccess'], adminOnlyCE: true },
    { to: 'portainer.endpoints' }
  );
  const {
    params: { id },
  } = useCurrentStateAndParams();
  const router = useRouter();

  const environmentId = parseInt(id, 10) as EnvironmentId;
  const environmentQuery = useEnvironment(environmentId);
  const groupQuery = useGroup(environmentQuery.data?.GroupId);
  const environment = environmentQuery.data;
  const group = groupQuery.data;

  return (
    <>
      <PageHeader
        title="Environment access"
        breadcrumbs={[
          { label: 'Environments', link: 'portainer.endpoints' },
          {
            label: environment?.Name ?? '',
            link: 'portainer.endpoints.endpoint',
            linkParams: { id: environmentId },
          },
          'Access management',
        ]}
        reload
      />
      <EnvironmentDetailsWidget
        environment={environment}
        group={group}
        isLoading={environmentQuery.isLoading || groupQuery.isLoading}
      />
      <CreateAccessWidget
        environment={environment}
        group={group}
        onSuccess={() => router.stateService.reload()}
        isLoading={environmentQuery.isLoading || groupQuery.isLoading}
      />
      <AccessDatatableWrapper environment={environment} group={group} />
    </>
  );
}
